import script from "./DerivationProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./DerivationProgress.vue?vue&type=script&setup=true&lang=js"

import "./DerivationProgress.vue?vue&type=style&index=0&id=ef0d964e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef0d964e"]])

export default __exports__